export const REDIRECT_QUERY_PARAM_SLUG = 'redirect_reason'

export const REDIRECT_REASONS = {
  OFFER_NOT_AVAILABLE: 'offer-not-available',
}
